import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { colors } from "../../theme/theme";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Link, useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress, useMediaQuery } from "@mui/material";
import { CustomPasswordInput, CustomInput } from "../../components/CustomInput";
import CustomBtn from "../../components/CustomBtn";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../constants/config";
import {
  ErrorSnackbar,
  ConfirmationSnackbar,
} from "../../components/CustomSnackbar";
import { useDispatch } from "react-redux";
import {
  getUserById,
  setUserRole,
} from "../../redux/dispatchers/login";

export default function Login() {
  const navigate = useNavigate();
  const smallScreen = useMediaQuery("(max-width:800px)");

  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");
  const [success, setsuccess] = useState(false);
  const [successMsg, setsuccessMsg] = useState("");

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [otp, setotp] = useState("");
  const [showLogin, setShowLogin] = useState(true);
  const [timer, setTimer] = useState(120); // Timer starts at 120 seconds (2 minutes)
  const [isResendEnabled, setIsResendEnabled] = useState(false); // Resend disabled initially

  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (otp === "") {
      seterror(true);
      seterrorMsg("All fields are required");
    } else {
      setloading(true);
      seterror(false);
      await axios
        .post(
          `${BASE_URL}/user/login`,
          {
            email: email,
            password: password,
            otp: otp,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          setloading(false);
          seterror(false);
          if (res?.data?.user?.role === "vendor") {
            navigate("/vendor/dashboard");
            dispatch(setUserRole("vendor"));
          }
          dispatch(getUserById(res?.data?.user?.id))
            .then(() => {
              setloading(false);
              seterror(false);
              if (res?.data?.user?.isAdmin) {
                dispatch(setUserRole("admin"));
                navigate("/admin/dashboard");
              } else if (res?.data?.user?.isSupervisor) {
                dispatch(setUserRole("supervisor"));
                navigate("/supervisor/dashboard");
              } else if (res?.data?.user?.isDoctor) {
                dispatch(setUserRole("doctor"));
                navigate("/provider/patients");
              }
            })
            .catch((e) => {
              setloading(false);
              seterror(true);
              seterrorMsg(e.response?.data?.message);
            });
        })
        .catch((e) => {
          setloading(false);
          seterror(true);
          seterrorMsg(e.response?.data?.message);
        });
    }
  };
  const sendOtp = async (e) => {
    e.preventDefault();
    if (email === "" || password === "") {
      seterror(true);
      seterrorMsg("All fields are required");
    } else {
      await axios
        .post(
          `${BASE_URL}/user/sendotp`,
          {
            email: email,
            password: password,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          setShowLogin(false);
          setsuccess(true);
          setsuccessMsg("OTP has been sent to your email.");
          setIsResendEnabled(false); // Disable "Resend OTP" again
          setTimer(120); // Reset the timer to 2 minutes
          //countDown();
        })
        .catch((e) => {
          setloading(false);
          seterror(true);
          seterrorMsg(e.response?.data?.message);
        });
    }
  };
  const reSendOtp = async (e) => {
    e.preventDefault();
    if (email === "") {
      seterror(true);
      seterrorMsg("All fields are required");
      setShowLogin(true);
    } else {
      await axios
        .post(
          `${BASE_URL}/user/resendotp`,
          {
            email: email,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          setShowLogin(false);
          setsuccess(true);
          setsuccessMsg("OTP has been sent to your email.");
          setIsResendEnabled(false); // Disable "Resend OTP" again
          setTimer(120); // Reset the timer to 2 minutes
          // countDown();
        })
        .catch((e) => {
          setloading(false);
          seterror(true);
          seterrorMsg(e.response?.data?.message);
        });
    }
  };
  // const countDown = () => {
  //   if (timer > 0) {
  //     const countdown = setInterval(() => {
  //       setTimer((prevTimer) => prevTimer - 1);
  //       if (timer < 0) {
  //         setTimer(0); // Prevent negative values
  //         setIsResendEnabled(true); // Enable "Resend OTP"
  //         clearInterval(countdown);
  //       }
  //     }, 1000);

  //     return () => clearInterval(countdown); // Cleanup the interval
  //   } else {
  //     setTimer(0); // Prevent negative values
  //     setIsResendEnabled(true); // Enable "Resend OTP"
  //   }
  // };
  // Format timer in MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(countdown); // Cleanup the interval
    } else {
      setTimer(0); // Prevent negative values
      setIsResendEnabled(true); // Enable "Resend OTP"
    }
  }, [timer]);

  return (
    <Grid
      container
      component="main"
      sx={{ height: "100vh", backgroundColor: "#F7F8FA" }}
    >
      <CssBaseline />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={error}
        handleCloseError={seterror}
        errorMsg={errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={setsuccess}
        text={successMsg}
        action={true}
      />
      <Grid
        item
        xs={false}
        sm={5}
        md={6.5}
        sx={{
          backgroundImage: `url(${require("../../assets/images/login/banner2.webp")})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "40%",
            backgroundImage:
              "linear-gradient(180deg, rgba(8, 13, 27, 0) 0%, rgba(8, 13, 27, 0.9) 100%)", // Adjusted alpha value to make it darker
          }}
        />
        <img
          src={require("../../assets/images/logo_md.png")}
          alt="Logo"
          style={{
            position: "absolute",
            top: "7.5%",
            left: "7.5%",
          }}
        />
        <Typography
          sx={{
            fontWeight: "500",
            color: "#fff",
            fontSize: smallScreen ? "20px" : "28px",
            fontFamily: "FiraSans",
            position: "absolute",
            bottom: "10%",
            marginLeft: "7.5%",
          }}
        >
          Empowering Mental Wellness:
          <Typography
            sx={{
              fontWeight: "800",
              color: "#fff",
              fontSize: smallScreen ? "34px" : "44px",
              fontFamily: "FiraSans",
            }}
          >
            Transforming Lives Through Compassionate Online Hypnotherapy
          </Typography>
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={7}
        md={5.5}
        component={Paper}
        elevation={6}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#F7F8FA",
          position: "relative",
        }}
      >
        <Box
          sx={{
            my: smallScreen ? 0 : 6,
            mx: smallScreen ? 0 : 9,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            fontFamily="FiraSans"
            fontWeight={"bold"}
            color={colors.textColor}
            fontSize={34}
          >
            Sign in
          </Typography>
          <Typography
            component="h1"
            variant="body1"
            fontFamily="FiraSans"
            fontWeight={"400"}
            color={colors.subText}
            fontSize={18}
          >
            We’ve already met!
          </Typography>
          <Box component="form" noValidate sx={{ mt: 4, px: 8 }}>
            {showLogin ? (
              <>
                <CustomInput
                  value={email}
                  setValue={setemail}
                  placeholder="Email Address"
                  Icon={MailOutlineIcon}
                />
                <CustomPasswordInput
                  mT
                  mB
                  value={password}
                  setValue={setpassword}
                />

                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "20%",
                    backgroundImage: `url(${require("../../assets/images/login/bottom.webp")})`,
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CustomBtn
                    text="Sign in"
                    onClick={(e) => {
                      e.preventDefault();
                      sendOtp(e);
                    }}
                  />
                </Box>
              </>
            ) : (
              <>
                <CustomInput
                  value={otp}
                  setValue={setotp}
                  placeholder="Enter OTP"
                  Icon={MailOutlineIcon}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "20%",
                    backgroundImage: `url(${require("../../assets/images/login/bottom.webp")})`,
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column", // Arrange elements vertically
                    gap: 2, // Add spacing between elements
                  }}
                >
                  {/* Confirm OTP Button */}
                  <CustomBtn
                    text="Confirm OTP"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLogin(e);
                    }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    Resend OTP available in:{" "}
                    {isResendEnabled ? "00:00" : formatTime(timer)}
                  </Typography>
                  {/* Resend OTP Button */}
                  {isResendEnabled ? (
                    <Typography
                      variant="body2"
                      sx={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        reSendOtp(e);
                      }}
                    >
                      Resend OTP
                    </Typography>
                  ) : (
                    <Typography variant="body2" color="text.disabled">
                      Resend OTP is disabled
                    </Typography>
                  )}
                  {/* <Typography
                    variant="body2"
                    sx={{
                      mt: 2,
                      cursor: "pointer",
                      color: "blue", // Make it look like a link
                      textDecoration: "underline",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      reSendOtp(e);
                    }}
                  >
                    Resend OTP
                  </Typography>{" "} */}
                </Box>
                {/* <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  
                  <CustomBtn
                    text="Confirm OTP"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLogin(e);
                    }}
                  />
                </Box> */}
              </>
            )}
            {showLogin && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <Link to="/forgot-password" variant="body2">
                  Forgot password?
                </Link>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
